import { render, staticRenderFns } from "./dataExpress.vue?vue&type=template&id=4c97c130&scoped=true&"
import script from "./dataExpress.vue?vue&type=script&lang=js&"
export * from "./dataExpress.vue?vue&type=script&lang=js&"
import style0 from "./dataExpress.vue?vue&type=style&index=0&id=4c97c130&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c97c130",
  null
  
)

export default component.exports